 document.addEventListener("DOMContentLoaded", function () {
    // var header = document.querySelector('header'); 
    // const image_sticky = document.querySelector('.sticky-image-section-content');
    // if (header) {
    //   var headerHeight = header.offsetHeight;
    //   image_sticky.style.top = headerHeight+"px" + "60px";
    //   window.headerHeight = headerHeight;
    // }

    const mainContent = document.querySelector("main#MainContent");
    if (mainContent) {
      const checkYotpo = setInterval(() => {
        const yotpoWidget = document.querySelector(".yotpo-widget-loyalty-floater-widget");
        if (yotpoWidget) {
          const yotpoHeight = yotpoWidget.offsetHeight;
          if (yotpoHeight > 0) {
            mainContent.style.paddingTop = yotpoHeight + "px";
            console.log("Yotpo widget found:", yotpoHeight);
            clearInterval(checkYotpo); 
          }
        }
      }, 500); 
    }

    const hotspots = document.querySelectorAll(".hotspot");
    hotspots.forEach(function(hotspot) {
        const hotspot_svg = hotspot.querySelector('.hotspot-svg');
        const hotspot_product = hotspot.querySelector('.hotspot-product');
        hotspot_svg.addEventListener("click", function() {
            const svgId = hotspot_svg.getAttribute("data-id");
            const relatedProduct = hotspot_product.getAttribute("product-id");
            if (relatedProduct == svgId) {
                hotspot_product.classList.toggle('active_product');
                hotspot_svg.classList.toggle('rotate_svg');
            }
        });
    });
    });


document.querySelectorAll('.product-card-wrapper').forEach(card => {
  let variantsEl = card.querySelector('.product-variants-json');
  if (!variantsEl) {
    console.warn("No .product-variants-json found in", card);
    return;
  }
  let variants = JSON.parse(variantsEl.textContent);
  let sizeInputs = card.querySelectorAll('.size-options input[type="radio"]');
  let colorInputs = card.querySelectorAll('.product_color_swatch input[type="radio"]');
  let addToCartBtn = card.querySelector('.quick-add__submit');
  let hiddenInput = card.querySelector('.product-variant-id');
  // Loader + Tick function (only for size)
  function showLoaderOnSelectedSize(selectedInput, callback) {
    const label = document.querySelector(
      `.size-options input[type="radio"][value="${selectedInput.value}"]:checked + label`
    );
    if (!label) return;
    label.querySelectorAll(".sizeloading__spinner, .tick-mark").forEach(el => el.remove());
    const originalText = label.textContent;
    label.textContent = "";
    const loader = document.createElement("div");
    loader.classList.add("sizeloading__spinner");
    loader.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
        <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
      </svg>
    `;
    label.appendChild(loader);
    setTimeout(() => {
      loader.remove();
      const tick = document.createElement("div");
      tick.classList.add("tick-mark");
      tick.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" 
          viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" 
          stroke-linecap="round" stroke-linejoin="round" 
          class="feather feather-check">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      `;
      label.appendChild(tick);
      setTimeout(() => {
        tick.remove();
        label.textContent = originalText;
      }, 1000);
      if (callback) callback();
    }, 1000);
  }
  function updateInputStates() {
    const selectedColor = card.querySelector('.product_color_swatch input[type="radio"]:checked')?.value;
    const selectedSize = card.querySelector('.size-options input[type="radio"]:checked')?.value;
    colorInputs.forEach(colorInput => {
      const colorValue = colorInput.value;
      const hasAvailableVariant = variants.some(v =>
        v.options[0] === colorValue &&
        (selectedSize ? v.options[1] === selectedSize : true) &&
        v.inventory_quantity > 0
      );
      colorInput.classList.toggle('visually-disabled', !hasAvailableVariant);
    });
    sizeInputs.forEach(sizeInput => {
      const sizeValue = sizeInput.value;
      const hasAvailableVariant = variants.some(v =>
        v.options[1] === sizeValue &&
        (selectedColor ? v.options[0] === selectedColor : true) &&
        v.inventory_quantity > 0
      );
      sizeInput.classList.toggle('disabled', !hasAvailableVariant);
    });
  }
  function updateVariant() {
    let selectedOptions = [];
    let color = card.querySelector('.product_color_swatch input[type="radio"]:checked');
    if (color) selectedOptions.push(color.value);
    let size = card.querySelector('.size-options input[type="radio"]:checked');
    if (size) selectedOptions.push(size.value);
    let matchedVariant = variants.find(v => {
      return v.options.every((opt, i) => opt === selectedOptions[i]);
    });
    if (matchedVariant) {
      hiddenInput.value = matchedVariant.id;
      console.log({
        title: matchedVariant.title,
        combination: matchedVariant.options.join(" / ")
      });
      if (matchedVariant.available && matchedVariant.inventory_quantity > 0) {
        addToCartBtn.disabled = false;
      } else {
        addToCartBtn.disabled = true;
      }
    } else {
      console.warn("No matching variant found for", selectedOptions);
      addToCartBtn.disabled = true;
    }
    updateInputStates();
  }
  // Size selection → Add to Cart auto
  sizeInputs.forEach(input => {
    input.addEventListener('click', () => {
      updateVariant();
      if (!addToCartBtn.disabled) {
        showLoaderOnSelectedSize(input, () => {
          addToCartBtn.click();
        });
      }
    });
  });
  // Color selection → variant update, no Add to Cart
  colorInputs.forEach(input => {
    input.addEventListener('click', () => {
      updateVariant();
    });
  });
  updateInputStates();
  updateVariant();
});






  //   const videos = document.querySelectorAll("video[data-src]");
  //   const observer = new IntersectionObserver(entries => {
  //     entries.forEach(entry => {
  //       if (entry.isIntersecting) {
  //         const video = entry.target;
  //         const source = document.createElement("source");
  //         source.src = video.getAttribute("data-src");
  //         source.type = "video/mp4";
  //         video.appendChild(source);
  //         video.load();
  //         observer.unobserve(video);
  //       }
  //     });
  //   });
  //   videos.forEach(video => observer.observe(video));
  // });




